import { MoneyMapFilterState } from '@fruitful/money-map';
import {
    BodyMediumRegular,
    CreditCardIcon,
    GoalIcon,
    Icon,
    MoneyMapIcon,
    ReceiptTextIcon,
    XStack,
} from 'smoothie';

const FILTER_CONTENT = {
    [MoneyMapFilterState.BILLS]: {
        backgroundColor: '$waterLightest',
        color: '$waterDarkest',
        icon: ReceiptTextIcon,
        text: 'We keep enough here to pay your bills each month, then the rest flows to your spending and goals accounts.',
    },
    [MoneyMapFilterState.SPEND]: {
        backgroundColor: '$leafLightest',
        color: '$leafDarkest',
        icon: CreditCardIcon,
        text: 'Accounts for day-to-day spending like groceries, gas, fun stuff — ensuring you never dip into money for bills or goals.',
    },
    [MoneyMapFilterState.GOALS]: {
        backgroundColor: '$petalLightest',
        color: '$petalDarkest',
        icon: GoalIcon,
        text: 'Automate your monthly savings by priority, and use extra income to reach your goals even faster.',
    },
    [MoneyMapFilterState.ALL]: {
        backgroundColor: '$white',
        color: '$gray1200',
        icon: MoneyMapIcon,
        text: 'Tap above to explore your Money Map.',
    },
} as const;

interface MoneyMapVisualExplainerRedesignProps {
    filter: MoneyMapFilterState;
}

export const MoneyMapVisualExplainerRedesign = ({
    filter,
}: MoneyMapVisualExplainerRedesignProps) => {
    const { backgroundColor, color, icon, text } =
        FILTER_CONTENT[filter] ?? FILTER_CONTENT.ALL;
    const isAll = filter === MoneyMapFilterState.ALL;

    return (
        <XStack
            width="100%"
            alignItems={isAll ? 'center' : 'flex-start'}
            justifyContent={isAll ? 'center' : 'flex-start'}
            gap={16}
            paddingHorizontal={isAll ? 16 : 20}
            paddingVertical={isAll ? 24 : 20}
            borderRadius={isAll ? 0 : 28}
            backgroundColor={backgroundColor}
        >
            <Icon icon={icon} color={color} size={isAll ? 28 : 24} />
            <BodyMediumRegular
                flex={isAll ? undefined : 1}
                color={color}
                fontStyle={isAll ? 'normal' : 'italic'}
            >
                {text}
            </BodyMediumRegular>
        </XStack>
    );
};
